import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import CreditNotePicker from '../components/Sales/avoir/CreditNotePicker';
import { CreditNoteBody } from '../components/Sales/avoir/CreditNoteDrawer';
import { emoText } from './EmojiIcons';
import DrawerHeader from './drawer/DrawerHeader';
import useActionLabel from '../i18n/useActionLabel';

// 47204 - the ONE customer credit-note door in the + Create host (global + Create, every Sales "+ Data Entry", worklist, order tabs, banner, discount panel). Ids 'credit-note-customer' only.
// Params: {operationId} -> order locked, straight to the drawer; {partner_id, partner_name} -> customer locked, picker offers that customer's orders; none -> customer > order picker first.
// Optional: amount, sourceRef (pre-tick that event), draftId (reopen that draft). The body is CreditNoteBody (never the framed CreditNoteDrawer: no nested drawer).
export default function CreditNoteDoorForm({ size, onSize, onClose, onInteract, params }) {
  const { t, i18n } = useTranslation('avoir'); const al = useActionLabel();
  const p = params || {};
  const pid0 = p.partner_id || p.partnerId || ''; const name0 = p.partner_name || p.partnerName || p.customer || '';
  const [pick, setPick] = useState(p.operationId ? { operationId: p.operationId, partnerId: pid0, customerName: name0 } : null);
  const [hdr, setHdr] = useState(null);   // the order's own header, when the door knew the order but not its customer
  const op = pick ? pick.operationId : '';
  const needHdr = !!op && !(pick.partnerId && pick.customerName);
  useEffect(() => {
    if (!needHdr) return undefined;
    let live = true;
    api.getSalesOrder(op).then((d) => { if (live && d && d.header) setHdr(d.header); }).catch(() => {});
    return () => { live = false; };
  }, [op, needHdr]);
  const head = <DrawerHeader eyebrow={t('eyebrow')} ini={String(i18n.language || '').startsWith('fr') ? 'AV' : 'CN'} title={<>{emoText(al('issueCustomerCreditNote'))}</>} size={size} onSize={onSize} onClose={onClose} />;
  if (!pick) return <>{head}<CreditNotePicker partnerId={pid0} partnerName={name0} lockPartner={!!pid0} onPick={setPick} onClose={onClose} onInteract={onInteract} /></>;
  const done = () => { onInteract && onInteract(false); onClose(); };
  return <CreditNoteBody operationId={op} partnerId={pick.partnerId || (hdr && hdr.partner_id) || ''} customerName={pick.customerName || (hdr && hdr.customer_name) || ''}
    amount={p.amount ?? null} initialSourceRef={p.sourceRef || ''} draftId={p.draftId || p.draft_id || ''} size={size} onSize={onSize} onClose={onClose} onDone={done} onInteract={onInteract} />;
}
